var _path, _rect, _rect2, _rect3, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 292 368",
    style: {
      enableBackground: "new 0 0 292 368"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Room&apos;s logo - Mighty frame of inconceivable truth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "illustration__frame-bg",
    d: "M292,0H0v368h292V0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "illustration__frame-face",
    x: 33,
    y: 39.8,
    width: 226,
    height: 259.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "illustration__frame-hair",
    x: 33,
    y: 32,
    width: 226,
    height: 15.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "illustration__frame-beard",
    x: 33,
    y: 262.7,
    width: 226,
    height: 73.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration__face-group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "illustration__eyebrow",
    x: 157,
    y: 72.6,
    width: 36,
    height: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "illustration__eye",
    d: "M157,121c0,9.9,8.1,18,18,18s18-8.1,18-18l0,0c0-9.9-8.1-18-18-18S157,111.1,157,121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "illustration__eye-closed",
    d: "M157,121c0,4.6,8.1,4.6,18,4.6s18,0,18-4.6l0,0c0-4.6-8.1-4.6-18-4.6S157,116.4,157,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "illustration__nose",
    points: "193,243 99,243 99,103 117,103 117,225 193,225  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "illustration__mouth",
    x: 157,
    y: 279.2,
    width: 36,
    height: 18.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "illustration__frame-border",
    d: "M275,17v334H17V17H275 M292,0H0v368h292V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.27940cf8ec0137e086bcf88d239ac13b.svg";
export { ForwardRef as ReactComponent };